import React from 'react';

import Figure from 'react-bootstrap/Figure';

import {apiBaseUrl} from './Config';

import './Adventure.css';

class Adventure extends React.Component {
    constructor(props) {
	super(props);

	this.fetchDocument = this.fetchDocument.bind(this);
    }

    fetchDocument(event) {
	const docUrl = apiBaseUrl + "downloadDocument.php/" + this.props.adventure.id;

	var filename = "";

	fetch(docUrl, {
	    headers: {
		"Authorization": "Bearer " + this.props.token
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}

		// Get the filename
		const header = response.headers.get('Content-Disposition');
		const parts = header.split(';');
		filename = parts[1].split('=')[1].replaceAll("\"", "");

		return response.blob();
	    })
	    .then(blob => {
		if (blob != null) {
		    var url = window.URL.createObjectURL(blob);
		    var a = document.createElement('a');
		    a.href = url;
		    a.download = filename;
		    document.body.appendChild(a);
		    a.click();
		    a.remove();
		}
	    })
	    .catch((error) => {
		this.setState({
		    error
		});
	    })

	event.preventDefault();
    }
    
    render() {
	var adventure = this.props.adventure;
	
	var thumbUrl = apiBaseUrl + "downloadThumb.php/" + adventure.id;
	
	return (
	    <Figure className="adventure">
		<a href="http://" onClick={this.fetchDocument}>
		    <Figure.Image src={thumbUrl} />
		</a>
		<Figure.Caption>
		    <a href="http://" onClick={this.fetchDocument}>
			{adventure.name}
		    </a>
		    <br />
		    {adventure.year}
		</Figure.Caption>
	    </Figure>
	);
    }
}

export default Adventure;
